<template>
  <div class="container_cm">
    <div class="main_cm">
      <div class="bh_cm">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/guidance' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>送检管理</el-breadcrumb-item>
          <el-breadcrumb-item>送检单</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="top_cm">
        <div>
          <span>订单号</span>
          <el-input  maxlength="100" v-model="searchForm.code" clearable placeholder="请输入订单号"></el-input>
          <span>状态</span>
          <el-select v-model="searchForm.states" clearable placeholder="请选择状态">
            <el-option v-for="item in eqStates" :key="item.key" :label="item.value" :value="item.key">
            </el-option>
          </el-select>
          <span>送检人</span>
          <el-input maxlength="50" v-model="searchForm.createUserName" clearable placeholder="请输入送检人"></el-input>
          <span>送检日期</span>
          <el-date-picker value-format="yyyy-MM-dd" v-model="searchForm.date" type="date" placeholder="选择送检日期">
          </el-date-picker>
        </div>
        <div>
          <el-button class="mybtny" v-waves icon="el-icon-search" @click="toSearch">搜索</el-button>
          <el-button class="mybtny" v-waves icon="el-icon-refresh-right" @click="reset">重置</el-button>
        </div>
      </div>
      <div class="table_cm">
        <Table ref="multipleTable" v-loading="loading" :tableData="List" :pageSize='pageSize' :currentPage="pageIndex" :cloumns="cloumns" :totalNum="total" :pageFlag='true' :selection='false' @handleCurrentChange="handleCurrentChange">
          <el-table-column prop="code" label="订单号" align="center">
          </el-table-column>
          <el-table-column prop="createUserName" label="送检人" align="center" sortable>
          </el-table-column>
          <el-table-column prop="phoneNumber" label="联系电话" align="center" sortable>
          </el-table-column>
          <el-table-column prop="mechanismName" label="检定单位" align="center" sortable>
          </el-table-column>
          <el-table-column prop="sendTime" label="送检日期" align="center" sortable>
          </el-table-column>
          <el-table-column prop="instrumentCount" label="仪器数量" align="center" sortable>
          </el-table-column>
          <el-table-column prop="remark" label="备注" align="center" sortable>
          </el-table-column>
          <el-table-column prop="hasDemotion" label="是否有仪器降级" align="center" sortable>
          </el-table-column>
          <el-table-column prop="states" label="状态" align="center">
            <template slot-scope="scope">
              <statusCom :type="scope.row.states"></statusCom>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click.native.prevent="detailClick(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </Table>
      </div>
    </div>
    <div>
      <el-dialog :visible.sync="detailVisible" width="1200px" v-if="detailVisible" top="5vh">
        <previewModel @cancel="cancelDetail" @save="save" @submitFiles="submitFiles" @deleteOrder="deleteOrder" @revokeOrder="revokeOrder" :preData="previewData"></previewModel>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { GetList, GetOne, Update, Delete, Revoke } from "@/api/VertifyOrder.js";
import previewModel from "@/components/previewModel";
import statusCom from "./components/statusCom";
import Table from "@/components/myTable";
export default {
  inject: ["reload"],
  components: {
    previewModel,
    statusCom,
    Table,
  },
  data() {
    return {
      userInfo: "",
      List: [],
      cloumns: [],
      loading: false,
      pageIndex: 1, //默认当前页
      pageSize: 10, //每页显示数量
      total: 0, //总条数
      searchForm: {},
      addVisible: false, //新增项目弹窗
      editVisible: false, //编辑项目弹窗
      editData: "", //待编辑项目数据
      eqStates: [
        { key: 1, value: "待送检" },
        { key: 2, value: "已送检" },
        { key: 3, value: "撤销" },
        { key: 4, value: "待确认" },
        { key: 5, value: "已完成" },
      ],
      detailVisible: false,
      previewData: null,
    };
  },
  created() {
    this.userInfo = this.$store.state.user.userInfo;
  },
  mounted() {
    this.getVertifyOrderList();
  },
  methods: {
    getVertifyOrderList() {
      let params = {
        deptId: this.userInfo.deptId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        ...this.searchForm,
      };
      if (this.searchForm.date) {
        params.startDate = this.searchForm.date + " 00:00:00";
        params.endDate = this.searchForm.date + " 23:59:59";
      }
      this.loading = true;
      GetList(params)
        .then((res) => {
          if (res.code == "200") {
            this.List = res.data.records;
            this.total = res.data.total;
          } else {
            this.$message.error(res.msg || "服务器连接失败");
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.msg || err.message || "服务器连接失败");
        });
    },
    toSearch() {
      this.pageIndex = 1;
      this.getVertifyOrderList();
    },
    reset() {
      this.pageIndex = 1;
      this.searchForm = {};
      this.getVertifyOrderList();
    },
    // 点击页码操作
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getVertifyOrderList();
    },
    // 刷新
    refresh() {
      this.reload();
    },
    // 新增项目
    addProject() {
      this.addVisible = true;
    },
    // 编辑项目
    editClick(row) {
      let { standardCode, standardName, version, fileName, filePath, id } = row;
      this.editData = {
        standardCode,
        standardName,
        version,
        fileName,
        filePath,
        id,
      };
      this.editVisible = true;
    },
    // 新增/编辑项目提交
    submit(data, isAdd) {},
    // 新增取消
    cancel() {
      this.addVisible = false;
    },
    // 编辑取消
    cancelEdit() {
      this.editVisible = false;
    },
    detailClick(row) {
      GetOne(row.id).then((res) => {
        this.previewData = res.data;
        this.detailVisible = true;
      });
    },
    cancelDetail() {
      this.detailVisible = false;
    },
    save(data) {
      Update(data).then((res) => {
        if (res.code == "200") {
          this.$message.success("保存成功");
          this.cancelDetail();
          this.getVertifyOrderList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    submitFiles(data) {
      Update(data).then((res) => {
        if (res.code == "200") {
          this.$message.success("送检成功");
          this.cancelDetail();
          this.getVertifyOrderList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    deleteOrder(data) {
      Delete(data).then((res) => {
        if (res.code === "200") {
          this.$message.success("删除成功");
          this.cancelDetail();
          this.getVertifyOrderList();
        } else {
          this.$message.success("删除失败");
        }
      });
    },
    revokeOrder(data) {
      Revoke(data).then((res) => {
        if (res.code === "200") {
          this.$message.success("撤销成功");
          this.cancelDetail();
          this.getVertifyOrderList();
        } else {
          this.$message.success("撤销失败");
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container_cm {
  width: 100%;
  height: calc(100% - 30px);
  padding: 15px 0;
  .main_cm {
    height: calc(100% - 82px);
    margin: 0 auto;
    .bh_cm {
      height: 20px;
      line-height: 20px;
    }
    .top_cm {
      margin: 10px 0;
      display: flex;
      justify-content: space-between;
      .el-input {
        width: 200px;
        margin: 0 20px;
      }
      .el-button {
        width: 140px;
        margin-left: 20px;
      }
      .el-select {
        margin: 0 20px;
      }
    }
    .table_cm {
      height: 100%;
      /deep/.el-table td {
        font-size: 14px;
      }
      /deep/.el-table__body td {
        padding: 10px 0;
      }
      .box-item-y {
        margin-left: 5px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: red;
        display: inline-block;
      }
      .box-item-n {
        margin-left: 5px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #74c8fe;
        display: inline-block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/VertifyOrder/index.vue